<template>
  <v-row id="stuff" justify="center">
    <v-dialog
      v-model="mainDialog"
      @input="dismiss($event)"
      scrollable
      max-width="345px"
    >
      <v-card height="200px">
        <v-card-text class="pr-0 pl-1 pt-2 pb-0">
          <ul id="emoticonss">
            <li v-for="(emoticon, index) in emoticons" :key="index">
              <img
                class="clickable"
                @click="select(emoticon)"
                :src="
                  require('@/assets/emoticons/' +
                    twemoji.convert.toCodePoint(emoticon) +
                    '.png')
                "
                width="20px"
                height="20px"
              />
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style scoped>
::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}

::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}

#emoticonss {
  padding: 0;
}

#emoticonss > li {
  display: inline;
  padding: 5px;
}
</style>

<script>
import { Emoticons } from "@/tools/config.js";
import twemoji from "twemoji";
export default {
  props: ["user"],
  data: () => ({
    mainDialog: false,
    emoticons: Emoticons,
    twemoji: twemoji,
    resolve: null
  }),
  methods: {
    dismiss(state) {
      if (!state && this.resolve !== null) {
        this.resolve(false);
      }
    },
    open() {
      this.mainDialog = true;
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    select(emoticon) {
      this.mainDialog = false;
      this.resolve(emoticon);
    }
  }
};
</script>
